/* QUIETUDE - « Buy 2, the 3rd is on us » sur la fiche produit.

   Ce fichier ne fait qu'AFFICHER l'offre et composer le lot. La deduction
   reelle vient d'une remise automatique Shopify appliquee au panier : le
   tiroir lit cart.total_price et final_line_price, donc l'affiche et le
   facture ne peuvent pas diverger.

   Si la remise Shopify est absente, expiree ou seulement planifiee, le bloc
   le detecte au premier lot ajoute et retire toute mention d'economie : il
   reste un composeur de lot, sans promesse de prix. Voir syncOffer().

   La nappe se parcourt en trois temps - la famille, la sous-collection, puis
   le bracelet. Avec quarante references, une liste unique a faire defiler ne
   tient pas. Une famille qui n'a qu'une seule sous-collection saute le palier
   du milieu : un ecran qui ne propose qu'un choix ne merite pas d'exister.
   L'arborescence vient telle quelle du snippet, ce fichier ne la decide pas.

   Il s'insere devant le formulaire d'achat que possede quietude-pdp.js :
   le listener est pose sur document en phase capture, donc il passe avant
   celui du formulaire, et ne l'intercepte que si le lot est complet.

   Tout degrade : sans JS le bloc n'apparait pas et le formulaire d'achat
   normal reste intact.

   LANGUE : tous les libelles passent par le dictionnaire L ci-dessous,
   choisi sur <html lang>. Le bloc etant entierement construit en JS, il ne
   traverse pas Translate & Adapt : sans ce dictionnaire un client francais
   lit « 1 added / Free / Add » au milieu d'une fiche en francais. Ajouter
   une langue = ajouter une entree, rien d'autre a toucher.

   FORMULATION : l'annonce dit « le 3e est offert », pas « le moins cher des
   3 ». La remise Shopify, elle, deduit toujours l'article le moins cher du
   lot - c'est la mecanique d'un BXGY et elle ne se regle pas ici. Les deux se
   contredisaient des que le client melangeait deux gammes de prix : le badge
   sautait sur le deuxieme emplacement.

   D'ou data-free-from : le dernier emplacement ne propose que la famille la
   moins chere du catalogue (ORIGINALS, 24,90 € contre 34,90 €). Le moins cher
   du lot est alors toujours ce troisieme bracelet, la deduction tombe dessus,
   et « le 3e est offert » devient litteralement vrai. Le snippet porte la
   valeur, ce fichier ne la decide pas.

   freeSet() reste le juge : si l'ecart de prix s'inversait un jour sans que
   FREE_FROM suive, le badge continuerait de designer l'article que le
   checkout deduira vraiment, quitte a ne plus etre le troisieme. */
(function () {
  if (window.__qtSetOffer) return;
  window.__qtSetOffer = true;

  var NBSP  = String.fromCharCode(160);
  var MINUS = String.fromCharCode(8722);
  var money = function (c) { return (c / 100).toFixed(2).replace('.', ',') + NBSP + '€'; };

  var FR = /^fr/i.test(document.documentElement.getAttribute('lang') || '');
  /* 1st, 2nd, 3rd, 4th - seul l'anglais en a besoin, le francais suffixe en e. */
  var ord = function (n) {
    var t = n % 100;
    if (t > 3 && t < 21) return n + 'th';
    return n + ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
  };

  var L = FR ? {
    pickBand:    'Choisir un bracelet',
    back:        'Retour',
    backToCols:  'Retour aux collections',
    backTo:      function (n) { return 'Retour à ' + n; },
    pickCol:     'Choisir une collection',
    anyN:        function (n) { return 'Composez votre lot de ' + n + '. Le ' + n + 'e est offert.'; },
    bandCount:   function (n) { return n + ' bracelet' + (n === 1 ? '' : 's'); },
    inYourSet:   function (n) { return n + ' dans votre lot'; },
    subsCount:   function (n, f) { return n + ' bracelets, en ' + f + ' finitions.'; },
    yourSetOf:   function (n) { return 'Votre lot de ' + n; },
    setComplete: 'Votre lot est complet',
    notRunning:  'L\'offre n\'est pas active en ce moment.',
    onUs:        function (names) { return 'Le bracelet ' + names.join(' et ') + ' est offert.'; },
    addMore:     function (k, n) { return 'Plus que ' + k + ' bracelet' + (k > 1 ? 's' : '') + ' et le ' + n + 'e est offert.'; },
    stepAdded:   function (i) { return i + ' ajouté' + (i > 1 ? 's' : ''); },
    stepFree:    'offert',
    tagFree:     'Offert',
    hintAdd:     'Ajouter',
    removeBand:  function (t) { return 'Retirer ' + t; },
    addBandN:    function (i) { return 'Ajouter le bracelet ' + i; },
    chosen:      function (n, s) { return n + ' sur ' + s + ' choisis'; },
    addTheSet:   function (m) { return 'Ajouter le lot ' + MINUS + ' ' + m; },
    payTheSet:   function (m) { return 'Payer le lot ' + MINUS + ' ' + m; },
    adding:      'Ajout…',
    youSave:     function (m) { return 'Vous économisez ' + m + ', déduits dans votre panier.'; },
    noteAdd:     function (k, n) { return 'Plus que ' + k + ' et le ' + n + 'e est offert.'; },
    cartError:   'Ajout au panier impossible',
    freeHead:    'Votre bracelet offert',
    freeSub:     function (col, n) { return 'Le ' + n + 'e est offert : à choisir dans ' + col + '.'; },
    anyNFrom:    function (n, col) { return 'Composez votre lot de ' + n + '. Le ' + n + 'e, offert, se choisit dans ' + col + '.'; }
  } : {
    pickBand:    'Choose a band',
    back:        'Back',
    backToCols:  'Back to collections',
    backTo:      function (n) { return 'Back to ' + n; },
    pickCol:     'Choose a collection',
    anyN:        function (n) { return 'Build your set of ' + n + '. The ' + ord(n) + ' is on us.'; },
    bandCount:   function (n) { return n + ' band' + (n === 1 ? '' : 's'); },
    inYourSet:   function (n) { return n + ' in your set'; },
    subsCount:   function (n, f) { return n + ' bands, in ' + f + ' finishes.'; },
    yourSetOf:   function (n) { return 'Your set of ' + n; },
    setComplete: 'Your set is complete',
    notRunning:  'The offer is not running at the moment.',
    onUs:        function (names) { return 'The ' + names.join(' and ') + ' band is on us.'; },
    addMore:     function (k, n) { return k + ' band' + (k > 1 ? 's' : '') + ' to go and the ' + ord(n) + ' is free.'; },
    stepAdded:   function (i) { return i + ' added'; },
    stepFree:    'free',
    tagFree:     'Free',
    hintAdd:     'Add',
    removeBand:  function (t) { return 'Remove ' + t; },
    addBandN:    function (i) { return 'Add band ' + i; },
    chosen:      function (n, s) { return n + ' of ' + s + ' chosen'; },
    addTheSet:   function (m) { return 'Add the set ' + MINUS + ' ' + m; },
    payTheSet:   function (m) { return 'Pay the set ' + MINUS + ' ' + m; },
    adding:      'Adding...',
    youSave:     function (m) { return 'You save ' + m + ', deducted in your cart.'; },
    noteAdd:     function (k, n) { return k + ' to go and the ' + ord(n) + ' is free.'; },
    cartError:   'Could not add to cart',
    freeHead:    'Your free band',
    freeSub:     function (col, n) { return 'The ' + ord(n) + ' is on us - pick it from ' + col + '.'; },
    anyNFrom:    function (n, col) { return 'Build your set of ' + n + '. The ' + ord(n) + ', on us, comes from ' + col + '.'; }
  };

  var ICO = {
    gift: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 12v9H4v-9M2 7h20v5H2zM12 21V7M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    x:    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    back: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    go:   '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>'
  };
  var esc = function (s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };
  var pic = function (url, w) {
    return '<span class="so-sw">' +
      (url ? '<img src="' + esc(url) + '" alt="" loading="lazy" width="' + w + '" height="' + w + '">' : '') +
      '</span>';
  };
  var focusQuietly = function (el) {
    if (!el) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  };

  function boot(root) {
    if (!root || root.dataset.bound) return;
    root.dataset.bound = '1';

    var BUY  = parseInt(root.getAttribute('data-buy'), 10)  || 2;
    var FREE = parseInt(root.getAttribute('data-free'), 10) || 1;
    var SIZE = BUY + FREE;

    var cat = { bands: [], groups: [] }, current = null;
    try { cat     = JSON.parse(root.getAttribute('data-catalog') || '{}'); } catch (e) {}
    try { current = JSON.parse(root.getAttribute('data-current') || 'null'); } catch (e) {}
    var BANDS  = cat.bands  || [];
    var GROUPS = cat.groups || [];
    if (!current || BANDS.length < SIZE - 1) { root.remove(); return; }

    /* La famille reservee a l'emplacement offert. On la retrouve par le handle
       et non par le titre : le titre change au gre de l'editeur, le handle non.
       Handle absent ou famille introuvable - collection vide, par exemple - et
       le troisieme choix redevient libre, comme avant. */
    var FREE_FROM = (root.getAttribute('data-free-from') || '').trim();
    var freeGi = -1;
    if (FREE_FROM) {
      GROUPS.forEach(function (g, i) { if (g && g.h === FREE_FROM) freeGi = i; });
    }

    var form = document.querySelector('form[data-add-form]');
    var cta  = form && form.querySelector('.mm-cta');

    /* Le portefeuille - Apple Pay, PayPal, « Acheter maintenant » selon le
       navigateur - ne sait porter qu'un article : Shopify le construit sur le
       seul champ `id` du formulaire, dans un cadre ferme dont le clic ne
       remonte jamais jusqu'a nous. Il part donc au paiement avec un bracelet,
       en sautant le panier, donc la remise. On ne peut pas le corriger, on ne
       peut que lui prendre la place : des qu'un lot se compose il s'efface, et
       une fois les trois choisis un bouton a nous occupe son rang - celui-la
       passe par le panier. Voir .so-express dans la feuille de style. */
    var buy     = form && form.closest('.mm-buy');
    var express = form && form.querySelector('.mm-express');
    var payBtn  = null;

    var slots = [current];
    for (var i = 1; i < SIZE; i++) slots.push(null);

    /* Passe a true si un lot complet arrive au panier sans qu'aucune remise
       ne s'applique : on cesse alors d'annoncer une economie. */
    var unbacked = false;

    /* Une seule regle de departage : le moins cher est offert, et a prix egal
       c'est le dernier choisi - sinon le badge designe un bracelet et la
       remise en deduit un autre. */
    function freeSet(list) {
      var filled = [];
      list.forEach(function (b, i) { if (b) filled.push({ b: b, i: i }); });
      var sets = Math.floor(filled.length / SIZE);
      if (!sets) return {};
      var out = {};
      filled.slice().sort(function (a, b) { return a.b.p - b.b.p || b.i - a.i; })
            .slice(0, sets * FREE).forEach(function (x) { out[x.i] = true; });
      return out;
    }
    function quote() {
      var free = unbacked ? {} : freeSet(slots);
      var gross = 0, saved = 0, n = 0, names = [];
      slots.forEach(function (b, i) {
        if (!b) return;
        n++; gross += b.p;
        if (free[i]) { saved += b.p; names.push(b.t); }
      });
      return { gross: gross, saved: saved, net: gross - saved, n: n, free: free, names: names };
    }

    /* ---- la nappe : famille, sous-collection, puis bracelet ---- */
    var sheet = document.createElement('aside');
    sheet.className = 'so-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', L.pickBand);
    sheet.innerHTML =
      '<span class="so-grab"></span>' +
      '<div class="so-sheet-head">' +
        '<button class="so-back" type="button" aria-label="' + esc(L.back) + '" hidden>' + ICO.back + '</button>' +
        '<div><p class="so-h"></p><p class="so-p"></p></div>' +
        '<button class="so-close" type="button" aria-label="' + esc(FR ? 'Fermer' : 'Close') + '">' + ICO.x + '</button>' +
      '</div>' +
      '<div class="so-body"></div>';
    var scrim = document.createElement('div');
    scrim.className = 'so-scrim';
    document.body.appendChild(scrim);
    document.body.appendChild(sheet);

    var elBack = sheet.querySelector('.so-back');
    var elH    = sheet.querySelector('.so-h');
    var elP    = sheet.querySelector('.so-p');
    var elBody = sheet.querySelector('.so-body');

    /* Ou l'on se trouve dans l'arborescence : [] la racine, [g] une famille,
       [g, s] une sous-collection. Une seule variable pour le retour, le titre
       et le re-rendu apres chaque ajout. */
    var nav = [];
    var lastFocus = null;
    var lockedAt = 0;

    /* Sans ce verrou le geste de defilement part a la page derriere au lieu
       de faire defiler la liste : la nappe reste immobile et le client croit
       qu'elle est bloquee. On fige donc la page, en retenant sa position
       pour la rendre intacte a la fermeture. */
    function lockPage(on) {
      var el = document.documentElement;
      if (on) {
        if (el.classList.contains('so-locked')) return;
        lockedAt = window.scrollY || window.pageYOffset || 0;
        el.classList.add('so-locked');
        document.body.style.top = (-lockedAt) + 'px';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else if (el.classList.contains('so-locked')) {
        el.classList.remove('so-locked');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        /* Le theme pose scroll-behavior:smooth sur <html>. Sans le neutraliser
           ici, rendre la position devient une animation qui n'aboutit pas et
           la fiche se retrouve en haut apres chaque fermeture. */
        var prev = el.style.scrollBehavior;
        el.style.scrollBehavior = 'auto';
        window.scrollTo(0, lockedAt);
        el.style.scrollBehavior = prev;
      }
    }

    /* lockPage(false) en dernier : c'est lui qui rend la position de la page,
       et tout ce qui suivrait - un focus notamment - la reprendrait. */
    function openSheet(state) {
      sheet.classList.toggle('on', state);
      scrim.classList.toggle('on', state);
      if (state) {
        lockPage(true);
        lastFocus = document.activeElement;
        focusQuietly(sheet.querySelector('.so-close'));
      } else {
        focusQuietly(lastFocus);
        lastFocus = null;
        lockPage(false);
      }
    }

    function taken() {
      var t = {};
      slots.forEach(function (b) { if (b) t[b.id] = (t[b.id] || 0) + 1; });
      return t;
    }

    /* Tous les index d'une famille, sous-collections confondues. Mis en cache :
       le compteur de la racine le redemande a chaque ouverture. */
    function idsOf(g) {
      if (!g._all) {
        var out = [];
        (g.subs || []).forEach(function (s) { out = out.concat(s.ids || []); });
        g._all = out;
      }
      return g._all;
    }
    function subsOf(g) { return (g && g.subs) || []; }
    /* Une famille a un palier intermediaire des qu'elle a deux entrees. */
    function tiered(g) { return subsOf(g).length > 1; }

    /* Un ajout va toujours dans le premier trou : le savoir suffit a dire si le
       prochain choix remplit l'emplacement offert, donc s'il est contraint. */
    function nextEmpty() {
      for (var i = 0; i < slots.length; i++) { if (!slots[i]) return i; }
      return -1;
    }
    function lockedPick() { return freeGi >= 0 && nextEmpty() === SIZE - 1; }

    /* Les variantes de la famille reservee, en dictionnaire : le garde-fou du
       clic doit repondre sur un id, pas sur un index de collection. */
    var _freeIds = null;
    function freeIds() {
      if (freeGi < 0) return {};
      if (!_freeIds) {
        _freeIds = {};
        idsOf(GROUPS[freeGi]).forEach(function (ix) {
          var b = BANDS[ix]; if (b) _freeIds[b.id] = true;
        });
      }
      return _freeIds;
    }

    /* Le point d'entree de la nappe : racine si le choix est libre, famille
       reservee sinon. Rien d'autre ne doit appeler showGroups() directement. */
    function openPicker() {
      if (lockedPick()) return showSubs(freeGi);
      return showGroups();
    }

    function row(attr, img, title, ids, t) {
      var picked = ids.reduce(function (s, ix) {
        var b = BANDS[ix]; return s + (b && t[b.id] ? t[b.id] : 0);
      }, 0);
      return '<button class="so-col" type="button" ' + attr + '>' +
        '<span class="so-col-media">' + pic(img, 132) + '</span>' +
        '<span class="so-col-text">' +
          '<span class="so-col-n">' + esc(title) + '</span>' +
          '<span class="so-col-c">' + esc(L.bandCount(ids.length)) +
            (picked ? ' · ' + esc(L.inYourSet(picked)) : '') + '</span>' +
        '</span>' +
        '<span class="so-col-go">' + ICO.go + '</span>' +
      '</button>';
    }

    function showGroups() {
      nav = [];
      elBack.hidden = true;
      elH.textContent = L.pickCol;
      elP.textContent = freeGi >= 0 ? L.anyNFrom(SIZE, GROUPS[freeGi].t) : L.anyN(SIZE);
      var t = taken();
      elBody.innerHTML = '<div class="so-cols">' + GROUPS.map(function (g, i) {
        return row('data-group="' + i + '"', g.img, g.t, idsOf(g), t);
      }).join('') + '</div>';
      elBody.scrollTop = 0;
    }

    function showSubs(gi) {
      var g = GROUPS[gi];
      if (!g) return showGroups();
      if (!tiered(g)) return showBands(gi, 0);
      var lock = lockedPick() && gi === freeGi;
      nav = [gi];
      /* Verrouille, cet ecran est le premier de la nappe : un retour ne mene
         nulle part et laisserait croire que les autres familles sont ouvertes. */
      elBack.hidden = lock;
      elBack.setAttribute('aria-label', L.backToCols);
      elH.textContent = lock ? L.freeHead : g.t;
      elP.textContent = lock ? L.freeSub(g.t, SIZE)
                             : L.subsCount(idsOf(g).length, subsOf(g).length);
      var t = taken();
      elBody.innerHTML = '<div class="so-cols">' + subsOf(g).map(function (s, si) {
        return row('data-sub="' + si + '"', s.img, s.t, s.ids || [], t);
      }).join('') + '</div>';
      elBody.scrollTop = 0;
    }

    function showBands(gi, si) {
      var g = GROUPS[gi];
      if (!g) return showGroups();
      var leaf = subsOf(g)[si] || subsOf(g)[0];
      if (!leaf) return showGroups();
      var deep = tiered(g);
      var lock = lockedPick() && gi === freeGi;
      nav = deep ? [gi, si] : [gi];
      /* Une famille sans palier intermediaire ouvre ici : verrouillee, c'est
         alors ce meme ecran qui n'a pas de retour. */
      elBack.hidden = lock && !deep;
      elBack.setAttribute('aria-label', deep ? L.backTo(g.t) : L.backToCols);
      elH.textContent = deep ? leaf.t : g.t;
      elP.textContent = lock ? L.freeSub(g.t, SIZE)
                             : (deep ? g.t + ' · ' : '') + L.bandCount((leaf.ids || []).length);
      var t = taken();
      elBody.innerHTML = '<div class="so-grid">' + (leaf.ids || []).map(function (ix) {
        var b = BANDS[ix];
        if (!b) return '';
        var n = t[b.id] || 0;
        return '<button class="so-cell" type="button" data-band="' + b.id + '"' +
          ' aria-pressed="' + (n ? 'true' : 'false') + '">' +
          '<span class="so-dot">' + pic(b.img, 92) + '</span>' +
          '<span class="so-cell-n">' + esc(b.t) + '</span>' +
          (n ? '<span class="so-cell-q">' + n + '</span>' : '') +
        '</button>';
      }).join('') + '</div>';
      elBody.scrollTop = 0;
    }

    /* Remonter d'un cran, et re-rendre la vue courante apres un ajout : les
       compteurs « dans votre lot » et les pastilles de quantite en dependent. */
    function goBack() {
      if (nav.length === 2) return showSubs(nav[0]);
      /* Verrouille, on est deja au premier ecran : Echap ferme, il ne remonte
         pas vers des familles que cet emplacement n'accepte pas. */
      if (lockedPick()) return openSheet(false);
      return showGroups();
    }
    function reshow() {
      if (!nav.length) return openPicker();
      if (nav.length === 1) return tiered(GROUPS[nav[0]]) ? showSubs(nav[0]) : showBands(nav[0], 0);
      return showBands(nav[0], nav[1]);
    }

    sheet.addEventListener('click', function (e) {
      if (e.target.closest('.so-close')) return openSheet(false);
      if (e.target.closest('.so-back'))  return goBack();

      var col = e.target.closest('[data-group]');
      if (col) return showSubs(parseInt(col.getAttribute('data-group'), 10));

      var sub = e.target.closest('[data-sub]');
      if (sub) return showBands(nav[0], parseInt(sub.getAttribute('data-sub'), 10));

      var cell = e.target.closest('[data-band]');
      if (!cell) return;
      var id = cell.getAttribute('data-band');
      var band = BANDS.filter(function (b) { return String(b.id) === id; })[0];
      if (!band) return;
      /* Le client pouvait rester sur la vue d'une autre famille apres son
         deuxieme ajout : sans ce garde-fou, un clic de plus posait un bracelet
         hors gamme dans l'emplacement offert. */
      if (lockedPick() && !freeIds()[band.id]) return openPicker();
      for (var i = 0; i < slots.length; i++) { if (!slots[i]) { slots[i] = band; break; } }
      draw();
      /* le lot n'est pas plein : on enchaine, sur l'ecran contraint si l'ajout
         suivant est celui de l'emplacement offert */
      if (quote().n < SIZE) { if (lockedPick()) openPicker(); else reshow(); }
      else openSheet(false);
    });
    scrim.addEventListener('click', function () { openSheet(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !sheet.classList.contains('on')) return;
      if (nav.length) goBack(); else openSheet(false);
    });

    /* ---- rendu du bloc ---- */
    root.innerHTML =
      '<div class="so-box">' +
        '<div class="so-head">' +
          '<p class="so-title">' + ICO.gift + ' <span data-t></span></p>' +
          '<p class="so-sub" data-s></p>' +
          '<div class="so-bar"><span class="so-fill" data-fill></span></div>' +
          '<div class="so-steps" data-steps></div>' +
        '</div>' +
        '<div class="so-slots" data-slots></div>' +
        '<div class="so-foot"><span class="so-meta" data-meta></span>' +
          '<span class="so-total" data-total></span></div>' +
      '</div>';

    var elT = root.querySelector('[data-t]'), elS = root.querySelector('[data-s]');
    var elFill = root.querySelector('[data-fill]'), elSteps = root.querySelector('[data-steps]');
    var elSlots = root.querySelector('[data-slots]'), elMeta = root.querySelector('[data-meta]');
    var elTotal = root.querySelector('[data-total]');
    var ctaLabel = cta ? cta.textContent.trim() : '';
    var note = null;

    elSteps.innerHTML = (function () {
      var out = [];
      for (var i = 0; i < SIZE; i++) {
        out.push('<span class="so-step" data-i="' + i + '">' +
          esc(i < BUY ? L.stepAdded(i + 1) : L.stepFree) + '</span>');
      }
      return out.join('');
    })();

    function draw() {
      var q = quote(), done = q.n === SIZE;

      elT.textContent = done
        ? (unbacked ? L.yourSetOf(SIZE) : L.setComplete)
        : root.getAttribute('data-label');
      elS.textContent = done
        ? (unbacked ? L.notRunning : L.onUs(q.names))
        : L.addMore(SIZE - q.n, SIZE);
      elFill.style.width = (q.n / SIZE * 100) + '%';
      elSteps.querySelectorAll('.so-step').forEach(function (s) {
        s.classList.toggle('on', q.n > parseInt(s.getAttribute('data-i'), 10));
      });

      elSlots.innerHTML = slots.map(function (b, i) {
        var isFree = unbacked ? false : (done ? !!q.free[i] : i === SIZE - 1);
        var cls = 'so-slot' + (isFree ? ' is-free' + (done ? ' unlocked' : '') : '');
        var tag = isFree ? '<span class="so-tag">' + esc(L.tagFree) + '</span>' : '';
        if (b) {
          return '<div class="' + cls + '" data-filled="1">' + tag +
            '<span class="so-dot">' + pic(b.img, 76) + '</span>' +
            '<span class="so-name">' + esc(b.t) + '</span>' +
            (i ? '<button class="so-x" type="button" data-clear="' + i +
                 '" aria-label="' + esc(L.removeBand(b.t)) + '">' + ICO.x + '</button>' : '') +
          '</div>';
        }
        return '<button class="' + cls + '" type="button" data-slot="' + i +
          '" data-filled="0" aria-label="' + esc(L.addBandN(i + 1)) + '">' + tag +
          '<span class="so-ico-plus">' + ICO.plus + '</span>' +
          '<span class="so-hint">' + esc(L.hintAdd) + '</span></button>';
      }).join('');

      elTotal.textContent = money(q.net);
      elMeta.innerHTML = q.saved
        ? '<s class="so-strike">' + money(q.gross) + '</s> ' +
          '<span class="so-plus-save">' + MINUS + money(q.saved) + '</span>'
        : esc(L.chosen(q.n, SIZE));

      if (cta) {
        cta.textContent = done ? L.addTheSet(money(q.net)) : ctaLabel;
        if (!note) {
          note = document.createElement('p');
          note.className = 'so-note';
          cta.parentNode.insertBefore(note, cta.nextSibling);
        }
        note.textContent = unbacked
          ? ''
          : (done ? L.youSave(money(q.saved)) : L.noteAdd(SIZE - q.n, SIZE));
        note.hidden = !note.textContent;
      }

      /* L'emplacement du portefeuille suit l'etat du lot : intact tant que
         rien n'a ete ajoute, efface des le premier ajout, occupe par notre
         bouton quand les trois sont la. */
      if (buy) {
        buy.classList.toggle('qt-set-armed', q.n > 1);
        buy.classList.toggle('qt-set-ready', done);
      }
      if (payBtn) {
        payBtn.hidden = !done;
        if (done) payBtn.textContent = L.payTheSet(money(q.net));
      }
    }

    root.addEventListener('click', function (e) {
      var clr = e.target.closest('[data-clear]');
      if (clr) {
        slots[parseInt(clr.getAttribute('data-clear'), 10)] = null;
        var kept = slots.filter(Boolean);
        slots = kept.concat(new Array(SIZE - kept.length).fill(null));
        return draw();
      }
      if (e.target.closest('[data-slot]')) { openPicker(); openSheet(true); }
    });

    /* La page de paiement, prefixee de la langue : depuis /fr, un /checkout nu
       renverrait le client dans la boutique anglaise. */
    var CHECKOUT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'checkout';

    /* Meme mesure que syncOffer : une remise a-t-elle mordu sur ce panier ? */
    function discountApplied(cart) {
      return (cart.total_discount || 0) > 0 ||
        (cart.items || []).some(function (it) { return (it.total_discount || 0) > 0; });
    }

    /* Un emplacement du lot - le premier surtout - peut deja etre au panier :
       ce meme bouton sert d'abord a l'achat simple, puis, une fois le lot
       complete, a « Ajouter le lot ». Sans ce controle, addSet() reposait
       systematiquement les trois bracelets et doublait celui deja ajoute :
       le panier facturait alors plus que ce que le bouton venait d'annoncer,
       et le client decrochait au paiement en voyant un total incoherent.
       On relit donc le panier reel juste avant d'ajouter, et on ne poste que
       les emplacements qui n'y sont pas deja. */
    function addSet(btn, checkout) {
      if (btn) { btn.disabled = true; btn.textContent = L.adding; }

      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var have = {};
          (cart.items || []).forEach(function (it) {
            have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity;
          });
          var items = [];
          slots.forEach(function (b) {
            if (!b) return;
            if (have[b.id] > 0) { have[b.id]--; return; }
            items.push({ id: b.id, quantity: 1 });
          });
          if (!items.length) return { ok: true, j: cart };

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: items })
          }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); });
        })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || L.cartError);
          return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          document.querySelectorAll('.mm-count, .cart-count, .hy-count').forEach(function (c) {
            c.textContent = cart.item_count;
          });
          lockPage(false);
          /* On n'envoie payer que si la remise a mordu : sinon le client
             trouverait au checkout un total superieur a celui qu'annoncait le
             bouton. Le tiroir prend alors le relais, deja corrige par
             syncOffer, et il voit son panier avant de decider. */
          if (checkout && discountApplied(cart)) { window.location.href = CHECKOUT; return; }
          if (typeof window.qtOpenCart === 'function') window.qtOpenCart(cart);
          syncOffer(cart);
        })
        .catch(function (err) { if (btn) btn.textContent = String(err.message).slice(0, 40); })
        .finally(function () {
          setTimeout(function () {
            if (cta) cta.disabled = false;
            if (payBtn) payBtn.disabled = false;
            draw();
          }, 1600);
        });
    }

    /* Capture sur document : on passe avant le listener que quietude-pdp.js
       pose sur le formulaire, et on ne lui prend la main que si le lot est
       complet. Sinon l'achat a l'unite suit son chemin habituel. */
    document.addEventListener('submit', function (e) {
      if (!form || e.target !== form) return;
      if (quote().n !== SIZE) return;
      e.preventDefault();
      e.stopPropagation();
      addSet(cta, false);
    }, true);

    /* Le bouton qui prend la place du portefeuille. Il vit dans .mm-express,
       donc il herite du rang que la section donne a cet emplacement et se pose
       exactement ou etait Apple Pay. Cree ici, montre par draw(). */
    if (express) {
      payBtn = document.createElement('button');
      payBtn.type = 'button';
      payBtn.className = 'so-express';
      payBtn.hidden = true;
      express.appendChild(payBtn);
      payBtn.addEventListener('click', function () {
        if (quote().n !== SIZE) return;
        addSet(payBtn, true);
      });
    }

    /* Un lot complet est au panier : si Shopify n'a rien deduit, la remise
       automatique est absente, expiree ou encore planifiee. On arrete alors
       d'annoncer une economie que le checkout ne fera pas. */
    function syncOffer(cart) {
      if (!cart || cart.item_count < SIZE) return;
      var applied = discountApplied(cart);
      if (applied === !unbacked) return;
      unbacked = !applied;
      root.classList.toggle('so-unbacked', unbacked);
      draw();
      if (unbacked && window.console) {
        console.warn('[QUIETUDE] Lot complet au panier, aucune remise appliquee : ' +
                     'la remise automatique « ' + root.getAttribute('data-label') +
                     ' » est absente, expiree ou planifiee. Le bloc cesse d\'annoncer l\'economie.');
      }
    }

    draw();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-set-offer]').forEach(boot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
